import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import Head from "../../Head/Head";
import NavBar from "../../NavBar/NavBar";
import ContactUs from "../../Forms/ContactUs/ContactUs";
import Footer from "../../Footer/Footer";
import Prefer from "../../Prefer/Prefer";
import Offices from "../../Offices/Offices";
import InstantQuote from "../../InstantQuote/InstantQuote";

import HeroImg from "../../../images/template-hero.png";
import HeroBanner from "../../../images/template-hero.jpg";

import LanguagesContents from "../../../data/languages";

import "./InterpretationTemplate.css";

const InterpretationTemplate = ({ language, location }) => {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const languageType = language
    .split(" ")
    .map((lang) => lang.charAt(0).toUpperCase() + lang.slice(1))
    .join(" ");

  const locationCap = location
    .split(" ")
    .map((lang) => lang.charAt(0).toUpperCase() + lang.slice(1))
    .join(" ");

  useEffect(() => {
    const checkLanguage = (lang) => {
      return lang.name.toLowerCase() === languageType.toLowerCase();
    };
    if (LanguagesContents.find(checkLanguage)) setOpen(true);
    else history.replace("/404");
  }, [history, languageType]);

  return (
    <>
      {open && (
        <div className="template position-relative">
          <Head
            title={`${languageType} interpretation services in ${locationCap} | certified ${languageType} interpreters in ${locationCap}`}
            description={`Get ${languageType} interpretation services in ${locationCap} with top certified ${languageType} interpreters in ${locationCap}. We offer ${languageType} interpretation services in ${locationCap} in over 250 languages.`}
            keywords={`translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous, interpretation services, multilingual services, sworn translators, certified translations, ${languageType}, ${locationCap}`}
          />
          <NavBar />
          <div className="template__hero container overflow-hidden d-flex f-50 align-center justify-between position-relative z-1">
            <div className="f-50 my-40">
              <div className="d-flex flex-column align-start justify-center">
                <h2 className="font-heading text-capitalise">
                  Professional {languageType} interpretation at Your Finger Tips
                </h2>
                <p className="font-bigger mt-40">
                  We provide {languageType} interpretation at the most
                  professional level bearing client specifics and interest at
                  the core of our services.
                </p>
                <a
                  href="/quote"
                  className="template__link mt-40 py-10 px-20 font-bold"
                >
                  REQUEST A QUOTE
                </a>
              </div>
            </div>
            <div className="d-flex flex-row-reverse justify-end overflow-hidden f-50">
              <img className="d-flex" src={HeroImg} alt="" />
            </div>
          </div>
          <img className="template__banner my-20" src={HeroBanner} alt="" />
          <div className="template__sec1 container d-flex flex-column align-center justify-between">
            <div className="">
              <h2 className="font-heading">
                {languageType} Interpretation services in {locationCap}
              </h2>
              <p className="my-40 lh-lg font-heavy">
                Oneconverse is a {languageType} interpretation service that
                provides high quality services at affordable prices. They offer
                services such as free {languageType} interpreter in{" "}
                {locationCap}, {languageType} interpretation for meetings and
                appointments, bilingual speaking and interpreting, and
                multi-language interpreting.Oneconverse is a trusted company
                with decades of expertise in the translation industry. They
                provide professional services such as free {languageType}
                interpreter in {locationCap}, {languageType} interpretation for
                meetings and appointments, bilingual speaking and interpreting,
                and multi-language interpreting to clients across the globe.{" "}
              </p>
              <p className="my-40 lh-lg font-heavy">
                Oneconverse has been around since 2006 and they have supported
                companies like Airbus, Microsoft, IBM to name a few with their
                professional translation services.{" "}
              </p>
              <p className="my-40 lh-lg font-heavy">
                The main goal of Oneconverse is to offer turnkey solutions for
                clients looking for simultaneous conference interpreting
                services. To help them meet these goals, they've developed an
                innovative software solution that automates and streamlines
                processes. {languageType} interpretation services in{" "}
                {locationCap} are absolutely essential for businesses, tourists,
                and individuals. There are a number of factors that make the{" "}
                {languageType} Interpreters in {locationCap} unique.Oneconverse
                is a trusted {languageType} interpretation service in{" "}
                {locationCap}. They provide qualitative and professional
                {languageType} translation services to their customers.
                Oneconverse has been on the market for 20 years and has seen
                tremendous growth with over 40% of their customers coming from
                the UK.
              </p>
              <a
                href="/quote"
                className="template__link my-40 py-10 px-20 font-bold"
              >
                REQUEST A QUOTE
              </a>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Oneconverse is a {languageType} interpretation service in{" "}
                  {locationCap} and offers professional and accurate{" "}
                  {languageType} interpreting services for businesses and
                  individuals.
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse has been acknowledged as one of the best{" "}
                  {languageType}
                  interpretation services in {locationCap}. With over 15 years
                  of experience, they offer high-quality interpretations at
                  affordable prices. They provide excellent services quickly,
                  all year round regardless of the time, day or
                  night.Oneconverse offers a range of professional translation
                  and interpreting services in English including: language
                  training, legal translation, medical translation, interpretive
                  reporting, technical translation and more.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  As a {languageType} interpreter in {locationCap}, Oneconverse
                  will be able to help you to find the right {languageType}{" "}
                  interpreter in {locationCap} and help you with your
                  translation or interpretation needs. The company’s main
                  objective is to provide a trusted and effective service and
                  they offer a range of services in this regard. These include:{" "}
                </p>
                <ol className="ml-40">
                  <li className="lh-lg font-heavy">
                    <strong>Translation:</strong> This service provides
                    professional They offer translation services for all types
                    of documents, such as contract proposals, legal agreements,
                    sales packets or technical specifications.
                  </li>
                  <li className="lh-lg font-heavy">
                    <strong>Interpretation:</strong> Interpretation: They also
                    provide interpreting services for conferences and meetings.
                  </li>
                </ol>
                <p className="lh-lg font-heavy">
                  Oneconverse is a trusted {languageType} interpretation service
                  based in {locationCap}. They provide {languageType}{" "}
                  interpretation services to clients in the UK and other
                  countries.Oneconverse offers translation, interpreting,
                  translation editing and transcription services. Their goal is
                  to help their clients achieve their goals with accuracy and
                  speed. They offer professional {languageType} interpreters who
                  are bilingual and experienced with the English language to
                  meet the needs of their different customers.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse has been providing professional translation
                  services since 2006, which gives them over 25 years of
                  experience in the industry. Through intensive training, they
                  ensure that their {languageType} interpreters are certified to
                  deliver high-quality interpretations or translations for
                  business meetings or conferences.Oneconverse is a{" "}
                  {languageType} interpretation service in {locationCap} that
                  provides the best {languageType} translations for their
                  clients. They provide professional interpreters in-person or
                  via video conferencing.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse offers {languageType} interpretation services in{" "}
                  {locationCap} in about 250 languages.
                  <br /> The most comprehensive interpretation services in
                  {locationCap}.Among their services are:
                </p>
                <ul>
                  <li>Short breaks for meetings</li>
                  <li>
                    Meeting packages with translation and interpretation
                    services
                  </li>
                  <li>Language training courses</li>
                  <li>Translation projects</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Why get {languageType} interpretation service in {locationCap}{" "}
                  to Oneconverse?
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse offer {languageType} interpretation service in{" "}
                  {locationCap}, which is a popular choice of language for
                  business people and travelers. They have been providing
                  services for over 15 years, and their bilingual {languageType}{" "}
                  interpretation services are available 24/7.
                </p>
                <h3 className="font-bigger py-40">Why Oneconverse?</h3>
                <ul className="lh-lg font-heavy pl-20">
                  <li>We have been providing services for over 15 years</li>
                  <li>
                    We provide professional quality interpreting in 250
                    languages including {languageType}
                  </li>
                  <li>
                    Our staff are multilingual with experience in many fields
                  </li>
                  <li>All our interpreters are certified</li>
                </ul>
                <p className="lh-lg font-heavy">
                  Oneconverse interpretation is located in {locationCap} and
                  offers
                  {languageType} interpretation services. They are the most
                  reliable and affordable translation company in the
                  city.Oneconverse offers both {languageType} interpretation
                  services and {languageType} translation services. They also
                  provide an excellent quality of English-{languageType}{" "}
                  interpreting service, which attracts many people to give them
                  a call.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Why get {languageType} interpretation service in {locationCap}
                  ?{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  The language barrier can greatly restrict communication
                  between people who speak different languages. A professional
                  interpreter can help bridge that gap by providing clear
                  pronunciation of words, making sure that both parties are
                  understood clearly, translating complex sentences into terms
                  they can easily understand, and providing accurate
                  translation.Oneconverse is a {languageType} interpretation
                  service in
                  {locationCap} that offers {languageType} interpretation
                  services in {locationCap}. Its service is not limited to the
                  capital only but also extends to other European cities as well
                  as North America.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Many companies or businesses need to hire a {languageType}
                  interpretation service in {locationCap}. It is not only
                  because they work in France but also because they want someone
                  who understands the context and can cater to a variety of
                  needs.Some businesses hire a {languageType} interpretation
                  service in
                  {locationCap} for their employees as well as their customers.
                  The company may be moving into a new market or opening up a
                  new branch across the globe, which means that it is important
                  that they have someone on-site who can help them with
                  translations.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse offers professional {languageType} interpretation
                  services in {locationCap}. This is an efficient process that
                  can ensure smooth communication between the client and the
                  interpreter.{languageType}
                  language is spoken by more than 200 million people across the
                  globe, so it's pretty challenging to find a good interpreter
                  for your {languageType} interview. With Oneconverse, you will
                  have everything covered - {languageType} interpretation
                  services in {locationCap}, customer service representatives or
                  specialists on call 24 hours a day seven days a week, quick
                  turnaround time with no wait time involved.We offer over 250
                  languages and our translator database has over 5000
                  interpreters sorted by specialization and language pair (e.g.:
                  Spanish/Spanish). Oneconverse also has own inventory of
                  translators with different qualifications like bilingual or
                  multilingual, which means you can always find an appropriate
                  translator for your project{" "}
                </p>
                <p className="lh-lg font-heavy">
                  When it comes to making an international trip, getting an
                  interpretation service is crucial. This is where Oneconverse
                  comes into play. Oneconverse provides {languageType}{" "}
                  interpretation services for clients all over {locationCap} and
                  its surrounding areas. It does not matter if you are traveling
                  to France or just visiting {locationCap} for a day -
                  Oneconverse is the perfect interpreter service for
                  you.Oneconverse offers more than just interpreting services;
                  they also provide translation services and {languageType}{" "}
                  language coaching to help you perfect your speaking skills!{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  The {languageType} Interpreters in {locationCap}, Providing
                  top {languageType}
                  interpretation services in {locationCap}
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse is an interpretation company that provides{" "}
                  {languageType}
                  Interpreter services to meet the needs of individual and
                  business clients. They have been in the business for over 25
                  years and offer high-quality services with a personal
                  touch.Oneconverse offers a wide range of {languageType}{" "}
                  interpretation services in {locationCap} from interpreting for
                  meetings to interpreting for conferences. They have
                  translators from various fields such as law, medicine,
                  banking, marketing and tourism.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  {languageType} Interpreters in {locationCap} are now available
                  at Oneconverse, the best interpretation company for{" "}
                  {languageType}
                  interpretation services in LondonOur {languageType}{" "}
                  interpretation services in {locationCap} is now an essential
                  for all companies in
                  {locationCap}. There are many ways to translate critical
                  information across different languages and cultures, but the
                  goal of translation is always to communicate between two
                  different sets of people or to understand how they feel about
                  something. Our {languageType} interpretation services in{" "}
                  {locationCap} provide a bridge that allows people from two
                  different language worlds to understand each other.
                  Oneconverse is the best place for
                  {languageType} interpreter services because we have a wide
                  range of experienced linguists with both native and non-native
                  accents, who can deliver high-quality translations with speed
                  and accuracy - all at an affordable price.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse is a translation service that offers{" "}
                  {languageType}
                  interpretation services in {locationCap}. We have the best{" "}
                  {languageType}
                  interpreters to help customers with their language needs.We
                  have over 10 years of person-to-person experience in the field
                  of interpreting which means that we are able to provide
                  quality services at affordable prices. Our team of 5000+
                  interpreters are fluent in both {languageType} and English so
                  they can translate spoken words, written text or sign
                  language.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Why Choose our {languageType} Interpretation services in{" "}
                  {locationCap}?{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  Our {languageType} Interpreters in {locationCap} are some of
                  the best in the business. They are highly qualified with great
                  skillsets and extensive knowledge on the {languageType}{" "}
                  language.We have an extensive list of interpreters who can
                  assist you 24/7 for your upcoming events, meetings,
                  presentations, conferences, interviews, personal meetings or
                  even if you need to get a translation done from English to{" "}
                  {languageType} or vice versa.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  We provide the best {languageType} interpretation services in{" "}
                  {locationCap}. We have the most experienced interpreter on
                  your side, who is well-versed in all types of {languageType}{" "}
                  language. Our team of interpreters also has expertise in
                  translating, interpreting, and providing cultural advice to
                  help you understand your foreign counterparts better.
                  {languageType} Interpretation Services in
                  {locationCap}{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">Why Choose Us? </h2>
                <p className="lh-lg font-heavy">
                  With our wide range of experience and skillsets, we are able
                  to translate written text between many different languages
                  with accuracy and fluency. This is why we’ve become so popular
                  with organizations across different industries who need their
                  documents translated into English or {languageType} for
                  business purposes.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Many people in {locationCap} are looking for a {languageType}{" "}
                  interpretation services. Our {languageType} interpreters in{" "}
                  {locationCap} have been trained to help people from different
                  areas of the world communicate more effectively.We provide all
                  our clients with a professional and reliable service that is
                  second to none. We have been serving the {locationCap} market
                  for over 15 years, helping thousands of businesses and
                  individuals communicate in a language they feel comfortable
                  with.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Our interpreters offer a wide range of services, ranging from
                  one-on-one appointments to large-scale conferences or meetings
                  across Europe or North America. Whether you need an
                  interpreter for your business meeting or your next holiday, we
                  have an option that suits you best! If you are looking for
                  professional {languageType} interpretation services in{" "}
                  {locationCap} that will provide you with high quality, fast
                  and accurate translation, then Oneconverse {languageType}{" "}
                  Interpretation service in
                  {locationCap} is the best place for you.
                </p>
              </div>
            </div>
          </div>
          <Prefer />
          <Offices />
          <ContactUs />
          <div className="container">
            <InstantQuote />
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default InterpretationTemplate;
